module.exports = __webpack_public_path__ + "img/i1.15b50c94.png";